module.exports = __webpack_public_path__ + "static/media/2 tiger portrait smoke realism tattoo chestpiece .1280x1413.215fbb40.webp";